import React from 'react';
import StaffPortalLogin from './StaffPortalLogin';

const DriverLogin = () => <StaffPortalLogin initialRole="driver" />;

export default DriverLogin;
